import { ColumnOrganizerType, ColumnType, DateColumnComponent, TableDefinition } from '@vendasta/va-filter2-table';
import { FacebookFormConfiguration } from './fb-forms-automation-configuration.service';
import { ConnectedCellComponent } from './fb-forms-table-custom-cells/connected-cell/connected-cell.component';
import { MarketDropDownCellComponent } from './fb-forms-table-custom-cells/market-dropdown-cell/market-dropdown.component';
import { FacebookFormsTableFilterService } from './fb-forms-table-filter-service';

const FB_FORMS_TABLE_DEF: TableDefinition = {
  id: 'facebook-forms-table',
  columns: [
    {
      id: 'formName',
      field: 'formName',
      displayName: 'LEAD_INTEGRATIONS.FACEBOOK.FORMS.FORM_NAME',
      translateCell: false,
      type: ColumnType.COLUMN_TYPE_STRING,
    },
    {
      id: 'connected',
      field: 'connected',
      displayName: 'LEAD_INTEGRATIONS.FACEBOOK.FORMS.CONNECTED',
      translateCell: false,
      type: ColumnType.COLUMN_TYPE_STRING,
      cellComponent: ConnectedCellComponent,
    },
    {
      id: 'market',
      field: 'market',
      displayName: 'LEAD_INTEGRATIONS.FACEBOOK.FORMS.MARKET',
      translateCell: false,
      cellComponent: MarketDropDownCellComponent,
    },
    {
      id: 'formID',
      field: 'formID',
      displayName: 'LEAD_INTEGRATIONS.FACEBOOK.FORMS.FORM_ID',
      translateCell: false,
      type: ColumnType.COLUMN_TYPE_STRING,
    },
    {
      id: 'locale',
      field: 'locale',
      displayName: 'LEAD_INTEGRATIONS.FACEBOOK.FORMS.LOCALE',
      translateCell: false,
      type: ColumnType.COLUMN_TYPE_STRING,
    },
    {
      id: 'createdAt',
      field: 'createdAt',
      displayName: 'LEAD_INTEGRATIONS.FACEBOOK.FORMS.CREATED_AT',
      translateCell: false,
      type: ColumnType.COLUMN_TYPE_DATE,
      cellComponent: DateColumnComponent,
    },
  ],
  columnOrganizerType: ColumnOrganizerType.ADVANCED_ORGANIZER,
  options: {
    selectableRows: false,
    tableTitle: 'LEAD_INTEGRATIONS.FACEBOOK.FORMS.TABLE_NAME',
    csvExportEnabled: false,
  },
  labels: {
    noResults: 'LEAD_INTEGRATIONS.FACEBOOK.FORMS.NO_RESULTS',
    cancel: 'COMMON.ACTION_LABELS.CANCEL',
    none: 'COMMON.ACTION_LABELS.NONE_LABEL',
    update: 'COMMON.ACTION_LABELS.UPDATE',
    sortBy: 'COMMON.TABLE.SORT.SORT_COLUMN_ORDER_DESCRIPTION_TEXT.SORT_BY',
    thenSortBy: 'COMMON.TABLE.SORT.SORT_COLUMN_ORDER_DESCRIPTION_TEXT.THEN_SORT_BY',
    addAnotherSortColumn: 'COMMON.TABLE.SORT.SELECT_COLUMN_PLACEHOLDER',
    chooseColumnToSortBy: 'COMMON.TABLE.SORT.SELECT_COLUMN_PLACEHOLDER_EMPTY_STATE',
    columnSorting: {
      date: {
        ascending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.EARLIEST_TO_LATEST',
        descending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.LATEST_TO_EARLIEST',
      },
      number: {
        ascending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS._1_TO_9',
        descending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS._9_TO_1',
      },
      string: {
        ascending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.A_TO_Z',
        descending: 'COMMON.TABLE.SORT.SORT_TOGGLE_LABELS.Z_TO_A',
      },
      default: {
        ascending: 'ascending',
        descending: 'descending',
      },
    },
    columnSelector: {
      buttonText: 'Select Columns',
    },
    export: {
      buttonText: '',
      buttonTooltipAfterCount: '',
      buttonTooltipBeforeCount: '',
    },
  },
  rowEqualityFunc: rowsEqual,
};

export function rowsEqual(any1: any, any2: any): boolean {
  const row1 = any1 as FacebookFormConfiguration;
  const row2 = any2 as FacebookFormConfiguration;
  return row1.formName === row2.formName && row1.formID === row2.formID && row1.createdAt === row2.createdAt;
}

export const tableDefinitionFactory = (filterService: FacebookFormsTableFilterService) => {
  const tableDefinition = FB_FORMS_TABLE_DEF;
  tableDefinition.filters = filterService.filters;
  return tableDefinition;
};
